import { render, staticRenderFns } from "./cat-complete-info.vue?vue&type=template&id=98a4d532&"
import script from "./cat-complete-info.vue?vue&type=script&lang=js&"
export * from "./cat-complete-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports